import { render, staticRenderFns } from "./SignAutomation.vue?vue&type=template&id=5ed2487a"
import script from "./SignAutomation.vue?vue&type=script&lang=js"
export * from "./SignAutomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports